import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import API from '@src/api';

export const getCountries = createAsyncThunk('common/getCountries', async () => {
  const data = await API.common.getCountries();
  return data;
});

export const { actions, reducer } = createSlice({
  name: 'common',
  initialState: {
    initialized: false,
    countries: [],
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getCountries.fulfilled, (state, { payload }) => {
      state.countries = payload.data;
    });
  },
});

// export const {  } = actions;

export default reducer;
